export default __webpack_public_path__ + "static/media/sun.b43eaaa9.svg";